<template>
  <div v-if="visivel" class="relatorio-empresas-selector mb-4">
    <div>
      <span class="relatorio-empresas-kicker">Relatório Multiempresa</span>
      <strong class="d-block">Empresas incluídas no PDF</strong>
      <small class="text-muted">
        Aplicado aos relatórios PDF compatíveis, com uma seção por empresa.
      </small>
    </div>

    <b-dropdown right variant="light-primary" menu-class="relatorio-empresas-menu">
      <template #button-content>
        <i class="fas fa-building mr-2"></i>{{ resumoSelecao }}
      </template>

      <div class="px-3 py-2">
        <div class="d-flex justify-content-between align-items-center mb-2">
          <strong>Selecionar empresas</strong>
          <button type="button" class="btn btn-link btn-sm p-0" @click="selecionarTodas">
            Todas
          </button>
        </div>

        <b-form-checkbox
          v-for="empresa in empresasDoGrupo"
          :key="empresa.id_empresa"
          v-model="selecionadas"
          :value="Number(empresa.id_empresa)"
          class="mb-2"
          @change="atualizarContexto"
        >
          {{ nomeEmpresa(empresa) }}
          <small v-if="Number(empresa.id_empresa) === empresaAtualId" class="text-muted">
            (atual)
          </small>
        </b-form-checkbox>
      </div>
    </b-dropdown>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  clearMultiEmpresaReportSelection,
  setMultiEmpresaReportSelection,
} from "@/modules/Relatorios/services/reportGeneration";

export default {
  name: "RelatorioEmpresasSelector",
  data() {
    return {
      selecionadas: [],
    };
  },
  computed: {
    ...mapGetters(["empresas", "empresaContexto"]),
    empresaAtualId() {
      return Number(this.empresaContexto?.id_empresa || 0);
    },
    grupoAtualId() {
      return Number(this.empresaContexto?.id_grupo_empresa || 0);
    },
    empresasDoGrupo() {
      if (!this.grupoAtualId) return [];

      return (this.empresas || [])
        .filter(
          (empresa) =>
            Number(empresa.id_grupo_empresa || 0) === this.grupoAtualId
        )
        .sort((a, b) => this.nomeEmpresa(a).localeCompare(this.nomeEmpresa(b)));
    },
    visivel() {
      return this.empresasDoGrupo.length > 1;
    },
    resumoSelecao() {
      if (this.selecionadas.length === this.empresasDoGrupo.length) {
        return `Todas as empresas (${this.selecionadas.length})`;
      }

      if (this.selecionadas.length === 1) {
        const empresa = this.empresasDoGrupo.find(
          (item) => Number(item.id_empresa) === Number(this.selecionadas[0])
        );
        return this.nomeEmpresa(empresa);
      }

      return `${this.selecionadas.length} empresas selecionadas`;
    },
  },
  watch: {
    empresaAtualId: {
      immediate: true,
      handler(idEmpresa) {
        this.selecionadas = idEmpresa ? [idEmpresa] : [];
        this.atualizarContexto();
      },
    },
  },
  beforeDestroy() {
    clearMultiEmpresaReportSelection();
  },
  methods: {
    nomeEmpresa(empresa) {
      return empresa?.nome_fantasia || empresa?.nome || "Empresa";
    },
    selecionarTodas() {
      this.selecionadas = this.empresasDoGrupo.map((empresa) =>
        Number(empresa.id_empresa)
      );
      this.atualizarContexto();
    },
    atualizarContexto() {
      this.$nextTick(() => {
        if (!this.selecionadas.length && this.empresaAtualId) {
          this.selecionadas = [this.empresaAtualId];
        }

        setMultiEmpresaReportSelection(this.selecionadas);
      });
    },
  },
};
</script>

<style scoped>
.relatorio-empresas-selector {
  align-items: center;
  background: #fff;
  border: 1px solid #e4e6ef;
  border-radius: 0.65rem;
  display: flex;
  justify-content: space-between;
  padding: 0.9rem 1rem;
}

.relatorio-empresas-kicker {
  color: #8950fc;
  display: block;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

@media (max-width: 767px) {
  .relatorio-empresas-selector {
    align-items: stretch;
    flex-direction: column;
    gap: 0.75rem;
  }
}
</style>

<style>
.relatorio-empresas-menu {
  min-width: 320px;
  max-height: 360px;
  overflow-y: auto;
}
</style>
